var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-hk",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M164.85 0h744.09v744.09H164.85z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.7 0 0 .7 -113.43 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ba0000",
    d: "M1063 744.094H0V.004h1063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.372 360.137s-75.02-32.3-64.255-116c10.42-40.29 28.828-67.727 62.17-82.66 15.63-4.864 31.607-6.948 47.93-8.337-4.284 4.052-7.872 8.104-9.724 13.198-3.59 9.146-.927 17.945 3.82 26.743 6.02 10.19 9.606 20.724 10.765 34.385 2.2 19.218-6.02 37.743-21.186 48.973-9.61 7.41-20.954 9.956-30.217 18.407-7.177 7.063-11.576 14.126-13.197 26.396-.232 23.387 6.137 26.63 13.894 38.9z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.132 239.037v-.347",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.127,
    fill: "#ba0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.872 351.447c-29.18-25.82-26.63-90.76-4.4-112.41",
    stroke: "#ba0000",
    strokeWidth: 3.127,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ba0000",
    d: "M501.898 223.064l9.61-2.165 1.144-9.37 4.78 8.03 9.608-2.18-6.657 7.127 4.794 8.02-8.894-3.622-6.646 7.136 1.16-9.365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.747 354.6s8.9-81.194 92.08-95.426c41.576-1.843 73.203 7.717 97.25 35.22 9.23 13.518 15.905 28.184 22.016 43.383-5.13-2.908-10.055-5.152-15.468-5.43-9.797-.752-17.43 4.372-24.45 11.488-7.977 8.74-17 15.258-29.72 20.37-17.73 7.732-37.85 5.302-53.032-5.907-9.9-7.018-15.66-17.117-26.454-23.498-8.857-4.792-16.9-6.928-29.105-4.883-22.428 6.63-23.662 13.67-33.12 24.683z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.36 305.5l.33-.103",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.127,
    fill: "#ba0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.272 342.97c16.137-35.466 78.974-52.056 106.187-37.146",
    stroke: "#ba0000",
    strokeWidth: 3.127,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ba0000",
    d: "M649.563 300.594l4.886 8.556 9.29-1.652-6.275 6.923 4.9 8.548-8.765-4.276-6.264 6.933.857-9.565-8.77-4.263 9.295-1.635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.353 360.463s79.814-17.346 119.728 57.006c14.95 38.836 15.93 71.86-2.51 103.4-9.887 13.043-21.674 24.03-34.145 34.652 1.13-5.788 1.69-11.17.236-16.392-2.397-9.528-9.68-15.138-18.657-19.535-10.822-4.788-19.866-11.273-28.753-21.713-12.964-14.356-17.05-34.206-11.242-52.16 3.51-11.617 11.257-20.285 13.88-32.547 1.73-9.92 1.202-18.223-4.614-29.148-13.41-19.16-20.477-18.095-33.924-23.568z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.357 450.702l.202.282",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.127,
    fill: "#ba0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.134 362.008c38.754 4.038 74.442 58.352 68.946 88.892",
    stroke: "#ba0000",
    strokeWidth: 3.127,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ba0000",
    d: "M619.836 463.56l-6.56 7.35 4.517 8.286-8.557-3.752-6.55 7.36 1.272-9.668-8.564-3.738 9.343-2.225 1.256-9.67 4.502 8.295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.556 368.693s39.062 71.732-21.09 130.92c-33.075 25.256-64.496 35.47-99.943 26.628-15.297-5.825-29.15-14.052-42.848-23.04 5.872-.54 11.196-1.512 15.798-4.375 8.472-4.977 11.81-13.543 13.51-23.394 1.556-11.73 5.24-22.23 12.764-33.692 10.137-16.474 28.04-25.97 46.905-25.438 12.134.106 22.63 5.108 35.134 4.18 10.007-1.124 17.828-3.963 26.68-12.613 14.623-18.25 11.616-24.735 13.092-39.177z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.977 472.74l-.214.273",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.127,
    fill: "#ba0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.662 381.395c7.008 38.327-35.098 87.833-65.952 91.135",
    stroke: "#ba0000",
    strokeWidth: 3.127,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ba0000",
    d: "M453.298 485.45l-8.896-4.234-6.684 6.662 1.197-9.266-8.903-4.22 9.637-1.494 1.18-9.27 4.76 8.343 9.634-1.508-6.697 6.65"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.706 367.138s-54.677 60.677-130.488 23.61c-34.81-22.806-54.885-49.048-58.323-85.42.412-16.362 3.57-32.163 7.494-48.068 2.46 5.358 5.147 10.057 9.376 13.447 7.51 6.336 16.697 6.64 26.553 4.97 11.58-2.43 22.71-2.446 36.02.843 18.906 4.088 33.81 17.82 39.577 35.788 3.93 11.48 2.7 23.04 7.73 34.527 4.385 9.065 9.662 15.498 20.762 20.973 22.072 7.728 27.188 2.738 41.3-.67z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.446 341.743l-.328-.112",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.127,
    fill: "#ba0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.426 373.345c-33.82 19.345-94.504-3.92-107.87-31.924",
    stroke: "#ba0000",
    strokeWidth: 3.127,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ba0000",
    d: "M383.244 336.836l1.036-9.797-8.505-4.092 9.138-1.95 1.02-9.798 4.613 8.593 9.135-1.965-6.286 7.26 4.625 8.585-8.5-4.107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/hk.1eb36876408074ac37856a4f9e5bae0c.svg";
export { ForwardRef as ReactComponent };